import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";

import * as ACTIONCONTANTS from "../../actions/ActionConstants";

interface IFormState {
  state: {
    sampleId: "";
    message: string[];
  };
}

class instrumentEndPosition extends EventEmitter implements IFormState {
  state: {
    sampleId: "";
    message: string[];
  };

  constructor() {
    super();

    this.state = {
      sampleId: "",
      message: [],
    };

    LMSDispatcher.register((e: any) => {
      // eslint-disable-next-line default-case
      switch (e.type) {
        case ACTIONCONTANTS.SAMPLE_END_POSITION:
          Object.assign(this.state, e.payload);
          this.emit("change", this.state);
          break;
      }
    });
  }
}
const sampleinstrumentEndPosition = new instrumentEndPosition();

export default sampleinstrumentEndPosition;
